<script setup lang="ts">
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  type ChartOptions,
  type ChartData,
} from 'chart.js'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const props = defineProps<{
  data: ChartData<'bar'>
  options?: ChartOptions<'bar'>
}>()

const defaultOptions: ChartOptions<'bar'> = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: 'rgba(42, 32, 24, 0.95)',
      padding: 12,
      cornerRadius: 8,
      titleFont: { size: 12, weight: 600 },
      bodyFont: { size: 12 },
    },
  },
  scales: {
    x: {
      grid: { display: false },
      ticks: {
        color: '#a8a29e',
        font: { size: 11 },
        maxRotation: 45,
        minRotation: 0,
        autoSkip: false,
      },
    },
    y: {
      beginAtZero: true,
      grid: { color: 'rgba(168, 162, 158, 0.1)' },
      ticks: { color: '#a8a29e', font: { size: 11 } },
    },
  },
}
</script>

<template>
  <Bar :data="props.data" :options="props.options || defaultOptions" />
</template>